<template>
  <div class="premium-page">
    <Premium v-on:showpremiummodal="getPremium"/>
  </div>
</template>
<script>
import Premium from '../components/Premium.vue'

export default {
  name: 'PremiumNoLogin',
  methods: {
    getPremium () {
      this.$router.push('/login')
    }
  },
  components: {
    Premium
  },
}
</script>

<style lang="scss">
  @import "../assets/styles/base.module";

  .premium-page {
    max-width: 1200px;
    margin: 0 auto;

    .content-block {
      height: auto;
    }
  }
</style>
